export enum ErrorIcons {
  ERROR = 'error',
  LOCKED = 'locked',
  NOT_FOUND = '404',
  REQUESTED = 'requested',
  BLOCKED = 'blocked',
  ENVELOPE = 'envelope',
  LOGIN = 'login',
}
